/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Circle, G, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function SpotifyLogo(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Circle
        cx={128}
        cy={128}
        r={96}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={8}
      />
      <G>
        <Path
          d="M179.1333,108.32931a112.19069,112.19069,0,0,0-102.3584.04859"
          fill="none"
          stroke={props.color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={8}
        />
        <Path
          d="M164.29541,136.71457a79.94058,79.94058,0,0,0-72.68359.04736"
          fill="none"
          stroke={props.color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={8}
        />
        <Path
          d="M149.47217,165.07248a47.97816,47.97816,0,0,0-43.03662.04736"
          fill="none"
          stroke={props.color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={8}
        />
      </G>
    </Svg>
  );
}

export default SpotifyLogo;
